module.exports = __webpack_public_path__ + "img/facepaint-1_cn.43255f7.jpg";